import SearchIcon from "@assets/images/magnifier.svg";
import RefreshIcon from "@assets/images/refresh-primary.svg";
import { Button } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import SingleTextFieldUnBlock from "@saleor/components/SingleTextField2/SingleTextField";
import TextInputDisable from "@saleor/components/TextInputDisable";
import { useGetScgpGdcDataQuery } from "@saleor/graphql";
import { makeStyles } from "@saleor/macaw-ui";
import ModalUserAD from "@saleor/userManagement/components/ModalUserAD";
import { UserDetailMode } from "@saleor/userManagement/constants";
import classNames from "classnames";
import { FormikProps } from "formik";
import React, { useState } from "react";
import SVG from "react-inlinesvg";
import { useIntl } from "react-intl";

export interface UserADProps {
  formik: FormikProps<any>;
  mode?: UserDetailMode;
}

const useStyles = makeStyles(
  theme => ({
    inputLabel: {
      marginBottom: 4,
      color: theme.palette.grey[900],
      fontSize: 14,
      fontWeight: 700
    },
    required: {
      color: theme.palette.error.main,
      marginLeft: 1,
      "& :after": {
        content: "*"
      }
    },
    routeSearch: {
      display: "flex",
      alignItems: "center",
      gap: 10
    },
    routerBtn: {
      order: 1,
      height: 38
    },
    textError: {
      color: theme.palette.error.light,
      marginTop: 5,
      fontSize: 12
    }
  }),
  { name: "UserAD" }
);

const UserAD: React.FC<UserADProps> = ({ formik, mode }) => {
  const classes = useStyles();
  const intl = useIntl();
  const [userAD, setUserAD] = useState<any>({});
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const { refetch: getScgpData } = useGetScgpGdcDataQuery({
    displayLoader: true,
    skip: true
  });

  const handleSearchUserAD = () => {
    if (formik.values.adUser && !formik.values.isScgp) {
      setLoading(true);
      getScgpData({
        adUser: formik.values.adUser
      }).then(res => {
        setLoading(false);
        if (!res.errors) {
          setUserAD({ ...res.data?.scgpGdcData, success: true });
          setOpenModal(true);
        } else {
          setOpenModal(true);
          setUserAD({ success: false });
        }
      });
    }
    if (formik.values.isScgp) {
      formik.resetForm();
      formik.setFieldValue("isScgp", false);
    }
  };

  const handleOnChoose = value => {
    const old = formik.values;
    formik.setValues({
      ...old,
      email: value.email,
      employeeId: value.employeeId,
      firstName: value.firstName,
      lastName: value.lastName,
      saleOrganizations: value.saleOrgs.map(item => item.id),
      isScgp: true,
      businessUnits: value.bus.map(item => item.id)
    });
    setOpenModal(false);
  };

  const getErrorText = field => (
    <div className={classes.textError}>{formik.errors[field]}</div>
  );

  return (
    <>
      <MyTypography variant={"subtitle3"} className={classes.inputLabel}>
        {intl.formatMessage({ defaultMessage: "AD User" })}
        <span className={classes.required}>*</span>
      </MyTypography>

      <div className={classes.routeSearch} data-testid="adUser-form">
        {formik.values.isScg || mode === UserDetailMode.EDIT ? (
          <TextInputDisable
            value={formik.values.adUser}
            testId="adUser-readonlyInput"
          />
        ) : (
          <SingleTextFieldUnBlock
            key={`adUser${formik.values.isScgp}`}
            name={"adUser"}
            id="adUser"
            placeholder="ระบุ AD User"
            value={formik.values.adUser}
            onChange={formik.handleChange}
            error={!!formik.errors.adUser}
            maxLengthProps={50}
            disabled={loading}
            clearAble={true}
          />
        )}

        <Button
          variant={"contained"}
          className={classNames("defaultB", classes.routerBtn)}
          onClick={handleSearchUserAD}
          disabled={mode === UserDetailMode.EDIT ? true : loading}
          id="adUserButton"
          name="adUserButton"
          data-testid="adUserButton"
        >
          <SVG src={formik.values.isScgp ? RefreshIcon : SearchIcon} />
        </Button>
      </div>
      {getErrorText("adUser")}
      <ModalUserAD
        result={userAD}
        open={openModal}
        onClose={() => setOpenModal(false)}
        onChoose={handleOnChoose}
      />
    </>
  );
};

export default UserAD;
